import type { IconAliases } from 'vuetify';

/**
 * Vuetify Icon Aliases
 *
 * https://vuetifyjs.com/en/features/icon-fonts/#icon-aliases
 *
 * Icon aliases allow you to define short, reusable names for icons that can map to different sources.
 * We can also override the icons Vuetify uses within their components.
 */
export const vuetifyAlias: Partial<IconAliases> = {
  alt: 'huge:option',
  arrowdown: 'huge:arrow-down-02',
  arrowleft: 'huge:arrow-left-02',
  arrowright: 'huge:arrow-right-02',
  arrowup: 'huge:arrow-up-02',
  backspace: 'huge:backspace',
  calendar: 'huge:calendar',
  cancel: 'huge:cancel-circle-solid',
  checkboxIndeterminate: 'custom:checkbox-indeterminate',
  checkboxOff: 'custom:checkbox-off',
  checkboxOn: 'custom:checkbox-on',
  clear: 'huge:cancel-circle-solid',
  close: 'huge:cancel',
  collapse: 'huge:arrow-up',
  color: 'huge:color',
  command: 'huge:command',
  complete: 'huge:tick',
  ctrl: 'huge:arrow-up',
  delete: 'huge:cancel-circle-solid',
  delimiter: 'huge:circle-solid',
  dropdown: 'huge:chevron-down',
  edit: 'huge:pencil-edit',
  enter: 'huge:arrow-move-down-left',
  error: 'huge:cancel-circle',
  expand: 'huge:arrow-down',
  eyeDropper: 'huge:color-picker',
  file: 'huge:attachment-02',
  first: 'huge:arrow-left-double',
  fullscreen: 'huge:full-screen',
  fullscreenExit: 'huge:full-screen-exit',
  info: 'huge:information-circle',
  last: 'huge:arrow-right-double',
  loading: 'huge:refresh',
  menu: 'huge:menu',
  minus: 'huge:minus-sign',
  next: 'huge:arrow-right',
  pause: 'huge:pause',
  play: 'huge:play',
  plus: 'huge:plus',
  prev: 'huge:arrow-left',
  radioOff: 'custom:radio-off',
  radioOn: 'custom:radio-button',
  ratingEmpty: 'huge:star',
  ratingFull: 'huge:rating-full',
  ratingHalf: 'huge:rating-half',
  shift: 'huge:arrow-up-03',
  sortAsc: 'huge:arrow-up-02',
  sortDesc: 'huge:arrow-down-02',
  space: 'huge:solid-line-01',
  subgroup: 'huge:chevron-down',
  success: 'huge:checkmark-circle-solid',
  tableGroupCollapse: 'huge:arrow-down',
  tableGroupExpand: 'huge:arrow-right',
  treeviewCollapse: 'huge:chevron-down',
  treeviewExpand: 'huge:chevron-right',
  unfold: 'huge:unfold-more',
  upload: 'huge:upload',
  volumeHigh: 'huge:volume-high',
  volumeLow: 'huge:volume-mute',
  volumeMedium: 'huge:volume-low',
  volumeOff: 'huge:volume-off',
  warning: 'huge:alert-diamond',

  // Custom Alias:
  copy: 'huge:copy',
  search: 'huge:search',
  trash: 'huge:delete'
};
